<div class="card" *ngIf="!!data">
  <div class="card-body" style="background-color: #EEEEEE;" *ngIf="loadingState == 'done'">
    <h5 class="card-title">E-KOMPLET {{ 'Standard.CaseERPSettings' | translate }}</h5>
    <h6 class="card-subtitle mb-2 text-muted">{{ 'Standard.CaseERPSettingsSubText' | translate }}</h6>
    <!-- Responsible -->
    <div class="dataItem" *ngIf="!!responsibles && responsibles.length > 0">
      <label class="dataItem-label">{{ 'Standard.Responsible' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.responsibleId" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option *ngFor="let x of responsibles" [value]="x.key">{{ x.value }}</option>
      </select>
    </div>
    <!-- Department -->
    <div class="dataItem" *ngIf="!!departments && departments.length > 0">
      <label class="dataItem-label">{{ 'Standard.Department' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eDimensionDepartmentId" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option *ngFor="let x of departments" [value]="x.id">{{ x.name }}</option>
      </select>
    </div>
    <!-- Order Group -->
    <div class="dataItem" *ngIf="!!orderGroups && orderGroups.length > 0">
      <label class="dataItem-label">{{ 'Standard.OrderGroup' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eOrderGroupId" (change)="updateParent()">
        <option *ngFor="let x of orderGroups" [ngValue]="x.id">{{ x.name }}</option>
      </select>
    </div>
    <!-- Carrier -->
    <div class="dataItem" *ngIf="!!dimensionCarrier && dimensionCarrier.length > 0">
      <label class="dataItem-label">{{ 'Standard.Carrier' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eDimensionCarrierId" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option *ngFor="let x of dimensionCarrier" [ngValue]="x.id">{{ x.name }}</option>
      </select>
    </div>
    <!-- Price Group -->
    <div class="dataItem" *ngIf="!!priceGroups && priceGroups.length > 0">
      <label class="dataItem-label">{{ 'Standard.PriceGroup' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.ePriceGroupId" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option *ngFor="let x of priceGroups" [ngValue]="x.id">{{ x.name }}</option>
      </select>
    </div>
    <!-- Profit Group -->
    <div class="dataItem" *ngIf="!!profitGroups && profitGroups.length > 0">
      <label class="dataItem-label">{{ 'Standard.ProfitGroup' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eProfitGroupId" (change)="updateParent()">
        <option *ngFor="let x of profitGroups" [ngValue]="x.id">{{ x.name }}</option>
      </select>
    </div>
    <!-- Purpose -->
    <div class="dataItem" *ngIf="!!purposes && purposes.length > 0">
      <label class="dataItem-label">{{ 'Word.Purpose' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eDimensionPurposeId" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option *ngFor="let x of purposes" [ngValue]="x.id">{{ x.name }}</option>
      </select>
    </div>
    <!-- Project Type -->
    <div class="dataItem">
      <label class="dataItem-label">{{ 'Standard.ProjectType' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eProjectType" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option [ngValue]="'enterprise'">Enterprise</option>
        <option [ngValue]="'spjæld'">Spjæld</option>
      </select>
    </div>
  </div>
  <div class="card-body mt-3 mb-3 text-center" *ngIf="loadingState != 'done'">
    {{ 'Standard.Loading' | translate }}...
    <button class="btn btn-primary m-auto mt-4" (click)="getTypes()" *ngIf="loadingState == 'error'">Hent E-KOMPLET data igen</button>
  </div>
</div>